// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.disease-in-session[data-v-ad84f3a8] {\n    color: #fff;\n    margin-left: 10px;\n    vertical-align: -4px;\n}\n", ""]);
// Exports
module.exports = exports;
